import React, {useState, useEffect} from 'react'
import ReactSlider from 'react-slider'
import {CriticalityValueModel} from '../../../../entities/component.entity'
import PrimaryButton from '../common/buttons/PrimaryButton'

// Define the shape of the value objects

// Define the props structure
interface EditCriticalitySettingsProps {
  isOpen: boolean
  onClose: () => void
  currentValues: {
    sysValues: CriticalityValueModel[]
    diaValues: CriticalityValueModel[]
    pulseValues: CriticalityValueModel[]
  }
  handleUpdate: (values: {
    sysValues: CriticalityValueModel[]
    diaValues: CriticalityValueModel[]
    pulseValues: CriticalityValueModel[]
  }) => void
}

const EditCriticalitySettingsModal: React.FC<EditCriticalitySettingsProps> = ({
  isOpen,
  onClose,
  currentValues,
  handleUpdate,
}) => {
  const [sysValues, setSysValues] = useState<CriticalityValueModel[]>([])
  const [diaValues, setDiaValues] = useState<CriticalityValueModel[]>([])
  const [pulseValues, setPulseValues] = useState<CriticalityValueModel[]>([])

  useEffect(() => {
    if (currentValues) {
      setSysValues(currentValues.sysValues)
      setDiaValues(currentValues.diaValues)
      setPulseValues(currentValues.pulseValues)
    }
  }, [currentValues])

  const handleChange =
    (setter: React.Dispatch<React.SetStateAction<CriticalityValueModel[]>>) =>
    (values: number[]) => {
      setter((prev) => prev.map((item, index) => ({...item, value: values[index]})))
    }

  const handleSave = () => {
    handleUpdate({sysValues, diaValues, pulseValues})
    onClose()
  }

  if (!isOpen) return null

  return (
    isOpen && (
      <div className='modal fade show d-block' tabIndex={-1}>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Edit Criticality General Settings</h5>
              <button type='button' className='btn-close' onClick={onClose}></button>
            </div>
            <div className='modal-body' style={{maxHeight: '400px', overflowY: 'auto'}}>
              <h5>Blood Pressure</h5>

              {/* Systolic (SYS) Slider */}
              <div className='mb-3'>
                <label className='form-label'>Systolic (SYS) Range</label>
                <ReactSlider
                  className='custom-slider'
                  thumbClassName='custom-thumb'
                  trackClassName='custom-track'
                  value={sysValues.map((item) => item.value)}
                  min={0}
                  max={300}
                  step={1}
                  onChange={handleChange(setSysValues)}
                  renderThumb={(props, state) => (
                    <div {...props} className='custom-thumb'>
                      {state.valueNow}
                    </div>
                  )}
                  pearling
                />
              </div>

              {/* Diastolic (DIA) Slider */}
              <div className='mb-3'>
                <label className='form-label'>Diastolic (DIA) Range</label>
                <ReactSlider
                  className='custom-slider'
                  thumbClassName='custom-thumb'
                  trackClassName='custom-track'
                  value={diaValues.map((item) => item.value)}
                  min={0}
                  max={300}
                  step={1}
                  onChange={handleChange(setDiaValues)}
                  renderThumb={(props, state) => (
                    <div {...props} className='custom-thumb'>
                      {state.valueNow}
                    </div>
                  )}
                  pearling
                />
              </div>

              <h5 className='mt-5'> Pulse</h5>

              {/* Pulse Slider */}
              <div className='mb-3'>
                <label className='form-label'>Pulse Range</label>
                <ReactSlider
                  className='custom-slider'
                  thumbClassName='custom-thumb'
                  trackClassName='custom-track'
                  value={pulseValues.map((item) => item.value)}
                  min={30}
                  max={200}
                  step={1}
                  onChange={handleChange(setPulseValues)}
                  renderThumb={(props, state) => (
                    <div {...props} className='custom-thumb'>
                      {state.valueNow}
                    </div>
                  )}
                  pearling
                />
              </div>

              <div className='d-flex justify-content-end pt-3'>
                <PrimaryButton onClick={handleSave}>Save</PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  )
}

export default EditCriticalitySettingsModal
